
const digest = 'cac94d858d01a4773db867637014b5ea348b01c984d25d2e0e1180bc6b93c34b';
const classes = {"wrapper":"_wrapper_xv92d_1","backdrop":"_backdrop_xv92d_16","sm":"_sm_xv92d_25","md":"_md_xv92d_30","lg":"_lg_xv92d_35","xl":"_xl_xv92d_40","modal":"_modal_xv92d_45","fullScreen":"_fullScreen_xv92d_64","header":"_header_xv92d_69","headerTitle":"_headerTitle_xv92d_78","close":"_close_xv92d_90","content":"_content_xv92d_99","maxHeight":"_maxHeight_xv92d_104","contentScroll":"_contentScroll_xv92d_108"};
const css = `._wrapper_xv92d_1 {
  position: fixed;
  z-index: 1050;
  background: rgba(6, 42, 96, 0.9);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  max-height: 100vh;
}

._backdrop_xv92d_16 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}

._sm_xv92d_25 {
  width: 300px !important;
  max-width: 300px !important;
}

._md_xv92d_30 {
  width: 500px !important;
  max-width: 500px !important;
}

._lg_xv92d_35 {
  width: 800px !important;
  max-width: 800px !important;
}

._xl_xv92d_40 {
  width: 1140px !important;
  max-width: 1140px !important;
}

._modal_xv92d_45 {
  background: #ffffff;
  width: fit-content;
  -webkit-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  min-width: 600px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 30px);
  max-height: calc(100vh - 30px);
}

@media (max-width: 600px) {
  ._modal_xv92d_45 {
    min-width: 100%;
  }
}
._fullScreen_xv92d_64 {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
}

._header_xv92d_69 {
  padding: 34px 24px;
  border-bottom: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

._headerTitle_xv92d_78 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Poppins, sans-serif;
  color: #212357;
  font-weight: 600;
  font-size: 18px;
  padding-right: 25px;
}

._close_xv92d_90 {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #d81616;
  cursor: pointer;
  text-decoration: underline;
}

._content_xv92d_99 {
  padding: 34px 24px;
  overflow-y: auto;
}

._maxHeight_xv92d_104 {
  height: calc(100vh - 180px);
}

._contentScroll_xv92d_108 {
  overflow-y: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  